<template>
    <section
        aria-label="Julgamentos do seller"
        class="overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700"
    >
        <div
            class="grid grid-cols-1 gap-px bg-gray-200 dark:bg-gray-700 sm:grid-cols-3"
        >
            <template v-if="loading">
                <div
                    v-for="n in 3"
                    :key="n"
                    class="space-y-2 bg-white px-4 py-3 dark:bg-gray-800"
                >
                    <div
                        class="h-2 w-16 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                    <div
                        class="h-4 w-40 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                    <div
                        class="h-2 w-32 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                </div>
            </template>

            <!-- Julgamento: pergunta + estado + evidência resumida. Clicar
                 abre a seção que sustenta a resposta (scroll + destaque). -->
            <button
                v-else
                v-for="signal in signals"
                :key="signal.key"
                type="button"
                :aria-label="`${signal.question} ${statusLabel(signal.status)}. ${signal.cta ?? ''}`"
                class="group flex flex-col items-start gap-1.5 bg-white px-4 py-3.5 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500 dark:bg-gray-800"
                :class="[
                    signal.section
                        ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/60'
                        : 'cursor-default',
                    wash(signal.status),
                ]"
                @click="signal.section && $emit('go', signal.section)"
            >
                <span class="flex w-full items-center justify-between gap-2">
                    <span
                        class="font-mono text-[10px] uppercase tracking-[0.16em] text-gray-400 dark:text-gray-500"
                    >
                        {{ signal.domain }}
                    </span>
                    <span
                        class="shrink-0 rounded-full px-2 py-0.5 font-mono text-[9px] uppercase tracking-widest"
                        :class="chip(signal.status)"
                    >
                        {{ statusLabel(signal.status) }}
                    </span>
                </span>

                <span
                    class="text-sm font-semibold text-gray-900 dark:text-white"
                >
                    {{ signal.question }}
                </span>

                <span
                    class="line-clamp-2 text-[11px] leading-relaxed text-gray-500 dark:text-gray-400"
                    :title="signal.reason"
                >
                    <highlighted-text :text="signal.reason" />
                </span>

                <span
                    class="mt-0.5 font-mono text-[11px]"
                    :class="
                        signal.section
                            ? 'text-indigo-500 group-hover:text-indigo-600 dark:text-indigo-400'
                            : 'text-gray-400 dark:text-gray-500'
                    "
                >
                    {{ signal.cta }}
                </span>
            </button>
        </div>
    </section>
</template>

<script>
import HighlightedText from "../../../views/monitoring/HighlightedText.vue";

export default {
    name: "SellerFarol",
    components: { HighlightedText },
    props: {
        // [{ key, domain, question, status: ok|attention|critical, reason,
        //    cta, section: chave da seção alvo ou null (sem pendência) }]
        signals: { type: Array, required: true },
        loading: { type: Boolean, default: false },
    },

    emits: ["go"],

    methods: {
        statusLabel(status) {
            return (
                {
                    ok: "ok",
                    attention: "atenção",
                    critical: "alerta",
                }[status] ?? "ok"
            );
        },

        chip(status) {
            return (
                {
                    attention:
                        "bg-amber-500/10 text-amber-600 dark:bg-amber-500/15 dark:text-amber-300",
                    critical:
                        "bg-rose-500/10 text-rose-600 dark:bg-rose-500/15 dark:text-rose-300",
                }[status] ??
                "bg-emerald-500/10 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-300"
            );
        },

        wash(status) {
            return (
                {
                    attention: "bg-amber-50/70! dark:bg-amber-500/4!",
                    critical: "bg-rose-50/70! dark:bg-rose-500/5!",
                }[status] ?? ""
            );
        },
    },
};
</script>
